import styled from "styled-components";
import { Typography } from "@dealer-center/core-components";
import { Locale } from "@dealer-center/ddc-core-utils";
import { formatCurrency } from "../utils/format";

const TotalContainer = styled.div<{ disabled?: boolean }>`
  margin-top: 20px;
  padding: 14px 8px;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  display: grid;
  grid-template-columns: 1fr 220px 150px 48px;
  gap: 8px;
  align-items: center;
  opacity: ${props => (props.disabled ? 0.5 : 1)};
  transition: opacity 0.2s;

  @media (max-width: 768px) {
    min-width: 490px;
  }
`;

const EmptyCell = styled.div``;

const LabelCell = styled.div`
  text-align: left;
`;

const SubLabel = styled.div`
  font-size: 12px;
  color: #4b5563;
  margin-top: 2px;
`;

const AmountCell = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

export interface TotalFeesDisplayProps {
  total: number;
  vehicleType: "NEW" | "USED";
  disabled?: boolean;
  locale?: string;
}

export const TotalFeesDisplay = ({
  total,
  vehicleType,
  disabled,
  locale = "en-US"
}: TotalFeesDisplayProps) => {
  const typeLabel = Locale.getText(
    vehicleType === "NEW"
      ? "FEEMANAGER_NEW_TOTALFEES"
      : "FEEMANAGER_USED_TOTALFEES"
  );

  return (
    <TotalContainer disabled={disabled}>
      {/* Empty cell for name column */}
      <EmptyCell />

      {/* Label in condition column */}
      <LabelCell>
        <Typography variant={"body-sm"}>{typeLabel}</Typography>
      </LabelCell>

      {/* Total amount in amount column */}
      <AmountCell>
        <Typography variant={"h3"}>{formatCurrency(total, locale)}</Typography>
      </AmountCell>

      {/* Empty cell for action column */}
      <EmptyCell />
    </TotalContainer>
  );
};
